import { createAction } from '@reduxjs/toolkit';

/**
 * Dispatched when @bear-auth/core emits `onAuthStateChanged` with `status: 'authenticated'`.
 */
export const authSessionStart = createAction('auth/sessionStart');

/**
 * Dispatched when @bear-auth/core emits `onAuthStateChanged` with `status: 'unauthenticated'`.
 */
export const authSessionEnd = createAction('auth/sessionEnd');
